import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportComponent } from './report/report.component';
import { ReportListComponent } from './report-list/report-list.component';
import { ReportsComponent } from './reports.component';
// import { HeaderComponent } from '../core/header/header.component';
// import { FooterComponent } from '../core/footer/footer.component';

const routes: Routes = [
  {
    path: '',
    component: ReportsComponent,
    children: [
      {
        path: '',
        component: ReportListComponent
      },
      {
        path: ':id',
        component: ReportComponent
      }
    ]
  },
  // { path: '', component: HeaderComponent, outlet: 'header' },
  // { path: '', component: FooterComponent, outlet: 'footer' }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})

export class ReportsRoutingModule { }

export const routedComponents = [ReportsComponent, ReportListComponent, ReportComponent];



// WEBPACK FOOTER //
// ./src/app/reports/reports-routing.module.ts